(function () {
  angular.module("akitabox.ui.components.dateTimeInput", [
    "akitabox.core.lib.moment",
    "akitabox.core.utils",
    "ngMaterial",
  ]);
})();
